export const PAYMENTS_MODE = 'http';           // ✅ siempre HTTP
export const USE_STRIPE_ELEMENTS = false;      // ✅ forzar off legacy
export const USE_LINK = false;                 // opcional: oculta Link
export const CHECKOUT_HTTP_URL =
  process.env.REACT_APP_CHECKOUT_HTTP_URL ||
  'https://us-central1-sistema-bks.cloudfunctions.net/createCheckoutSessionHttp';